export let keytipsDiagnosticDataDescription = "QFvff";
export default {keytipsDiagnosticDataDescription};